/* ═══════════════════════════════════════════════════════════════════════════
   The phone number
   Ported unchanged from the prototype. Booking requires the number because
   Vipps and SMS do not work without it, and it doubles as the customer's UID
   on the platform.
   ═══════════════════════════════════════════════════════════════════════ */

/** Strips everything that is not a digit, and the country code when the
    number is Norwegian. */
export function normalise(v) {
  return String(v == null ? '' : v)
    .replace(/[^\d+]/g, '')
    .replace(/^\+?47(?=\d{8}$)/, '')
    .replace(/\+/g, '');
}

/** A Norwegian mobile number: eight digits starting with 4 or 9. */
export function valid(v) {
  return /^[49]\d{7}$/.test(normalise(v));
}

/** The error message, or null. A landline gets its own, because it is the
    most common mistake and "invalid number" does not explain why. */
export function error(v) {
  const n = normalise(v);
  if (!n) return 'We need your mobile number.';
  if (n.length !== 8) return 'A Norwegian mobile number has eight digits.';
  if (!/^[49]/.test(n))
    return 'This looks like a landline. SMS and Vipps need a mobile number.';
  return null;
}

/** 412 34 567 */
export function format(v) {
  const n = normalise(v);
  if (n.length !== 8) return n;
  return n.slice(0, 3) + ' ' + n.slice(3, 5) + ' ' + n.slice(5);
}
